import styled from 'styled-components';
import {
  transparentize,
} from 'polished';

import {
  Flex,
} from 'web-styled';

interface EditorType {
  minHeight: string
  hidePlaceholder?: boolean
  hasFocus?: boolean
}

export const RichEditor = styled.div<EditorType>`
  width: 100%;
  border: solid 1px #cbd4d7;
  padding: 10px;
  border-radius: 5px;
  transition: all 0.3s;
  box-sizing: border-box;

  .DraftEditor-root {
    color: #797979;
    font-size: 16px;
    font-weight: 400;
    word-break: break-word;
    white-space: pre-wrap;
    box-sizing: border-box;
    tab-size: 8;

    .DraftEditor-editorContainer,
    .public-DraftEditor-content {
      min-height: ${props => props.minHeight};
    }

    .public-DraftEditorPlaceholder-root {
      color: #c1c1c1;
      font-size: 1em;

      ${props => props.hidePlaceholder && `
        display: none;
      `};
    }
  }

  ${props => props.hasFocus && `
    outline: 0;
    box-shadow: 0 0 0 0.2rem ${transparentize(0.75, props.theme.colors.primary)};
    border-color: ${(props.theme.colors.primary)};
    background-color: #fff;
  `};

  a {
    color: ${props => props.theme.colors.primary};
  }
`;

export const Controls = styled(Flex)`
  width: 100%;
  border-top: solid 1px #cbd4d7;
  margin-top: 10px;
  padding-top: 10px;

  & > *:not(:last-child) {
    margin-right: 10px;
  }
`;

export const Control = styled.span<{ isActive?: boolean }>`
  color: ${props => (props.isActive ? props.theme.colors.primary : '#797979')};
  width: 25px;
  height: 25px;
  line-height: 25px;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  border: solid 1px ${props => (props.isActive ? props.theme.colors.primary : '#cbd4d7')};
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Search = styled.div`
  position: relative;
  z-index: 9;

  & > div {
    width: 100%;
  }
`;
